/**
 * Phosphor's 256 grid at stroke 16, so these sit beside Phosphor icons.
 * Drawn from the object, not from another icon set.
 */

const circle = (cx: number, cy: number, r: number) =>
  `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${2 * r} 0a${r} ${r} 0 1 0 ${-2 * r} 0`;

const rect = (x: number, y: number, w: number, h: number, r = 0) =>
  r
    ? `M${x + r} ${y}H${x + w - r}a${r} ${r} 0 0 1 ${r} ${r}V${y + h - r}a${r} ${r} 0 0 1 ${-r} ${r}H${x + r}a${r} ${r} 0 0 1 ${-r} ${-r}V${y + r}a${r} ${r} 0 0 1 ${r} ${-r}Z`
    : `M${x} ${y}H${x + w}V${y + h}H${x}Z`;

export const GLYPHS = {
  hvac: [
    rect(40, 40, 176, 168, 16),
    circle(128, 128, 60),
    "M128 112Q123.4 84.2 152.4 82.1Q163.3 109.2 141.9 120M141.9 136Q168.2 145.9 155.6 172.1Q126.6 168 128 144M114.1 136Q92.4 153.9 76 129.8Q94.1 106.8 114.1 120",
    "M72 208v16M184 208v16",
  ],
  /** Seen through a furnace's sight glass. */
  heating: [
    "M128 224c-40 0-72-28-72-68 0-44 40-72 56-124 28 24 40 52 40 76 12-8 20-20 24-32 16 20 24 48 24 80 0 40-32 68-72 68Z",
    "M128 224c-16 0-28-12-28-28 0-20 16-32 28-52 12 20 28 32 28 52 0 16-12 28-28 28Z",
  ],
  /** Frost the way a coil ices. */
  cooling: [
    "M128 32v192M44.9 80l166.2 96M44.9 176l166.2-96",
    "M152 36L128 60L104 36M219.7 102.8L186.9 94L195.7 61.2M195.7 194.8L186.9 162L219.7 153.2M104 220L128 196L152 220M36.3 153.2L69.1 162L60.3 194.8M60.3 61.2L69.1 94L36.3 102.8",
  ],
  plumbing: [
    "M48 88h88a48 48 0 0 1 48 48v72M48 136h88v72",
    rect(24, 76, 24, 72, 6),
    rect(124, 208, 72, 24, 6),
  ],
  drains: [circle(128, 128, 92), "M92 72v112M128 60v136M164 72v112"],
  water_heater: [
    rect(64, 48, 128, 176, 28),
    "M100 48V24M156 48V24",
    rect(108, 168, 40, 28, 6),
    "M64 96h128",
  ],
  electrical: [
    "M100 32v40M156 32v40",
    "M68 72h120v48a60 60 0 0 1-120 0Z",
    "M128 180v52",
  ],
  job: [
    rect(52, 40, 152, 192, 14),
    rect(92, 24, 72, 36, 10),
    "M88 108h80M88 148h80M88 188h48",
  ],
  technician: [
    "M48 168a80 80 0 0 1 160 0",
    "M104 92v76M152 92v76",
    "M24 168h208v16a12 12 0 0 1-12 12H36a12 12 0 0 1-12-12Z",
  ],
  /** A business unit or a branch. */
  shop: [
    "M40 216V100l88-60 88 60v116",
    "M84 216v-88h88v88M84 160h88M84 188h88",
    "M24 216h208",
  ],
  /** A customer or a location. */
  home: ["M48 112l80-72 80 72v104H48Z", "M104 216v-60h48v60"],
  /** A vendor. */
  supplier: [
    rect(20, 64, 136, 112, 8),
    "M156 100h40l40 40v36h-80",
    circle(72, 192, 20),
    circle(188, 192, 20),
  ],
  /** Equipment or material on the job. */
  part: [
    "M40 80l88-44 88 44v96l-88 44-88-44Z",
    "M40 80l88 44 88-44M128 124v96",
  ],
} as const satisfies Record<string, readonly string[]>;

export type GlyphName = keyof typeof GLYPHS;
